import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'
import { messageActions } from '../../store/message'
import storage from '../../services/stoage.service'
import utils from '../../utils/index'
import { mensagensDeErro } from '../../utils/credencialMascarada'
const BASE_PATH = '/lottustech/configuracaoempresa'
const prefix = 'crudParametroEmpresa'
const crud = build(validate, BASE_PATH)

const mensagensErro = (err) =>
  mensagensDeErro(
    err,
    utils.getMessage(storage.getAppLabels('parametrosempresa'), 'parametrosempresa.label.falhaComunicacao')
  )

const newTypes = {
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)

const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

// Devolve se gravou, para quem precisa encadear (renomear so apaga a chave antiga depois de gravar a nova).
// recarregar = false: quem chama recarrega depois (renomear); a falha recarrega sempre.
actions.insertItemConfiguracao = (configuracaoItem, recarregar = true) => {
  return (dispatch) => {
    dispatch(actions.clearErrors())
    return api
      .post(BASE_PATH, configuracaoItem)
      .then((response) => {
        if (recarregar && actions.afterSave) {
          actions.afterSave()
        }
        return true
      })
      .catch((err) => {
        // O dialogo ja fechou: o usuario precisa saber que nao gravou (ou que pode nao ter gravado).
        dispatch(messageActions.showMessages(mensagensErro(err), 'error'))
        // Recarrega para mostrar o que ficou gravado (num lote recusado, nada).
        if (actions.afterSave) {
          actions.afterSave()
        }
        return false
      })
  }
}

// Devolve se removeu. Falha mostra a mensagem e recarrega (a tela tira a linha da grade ao remover).
actions.deleteKey = (key) => {
  return (dispatch) => {
    dispatch(actions.clearErrors())
    if (!key) {
      return Promise.resolve(false)
    }
    // Nome codificado: sem isso o navegador corta espaco no fim e trata ?, # e % como parte da URL - e o DELETE
    // apagava OUTRA chave (renomear "tokenAutentique " para "tokenAutentique" apagava a recem-gravada).
    return api
      .remove(`${BASE_PATH}/deleteKey/${encodeURIComponent(key)}`)
      .then(() => true)
      .catch((err) => {
        dispatch(messageActions.showMessages(mensagensErro(err), 'error'))
        if (actions.afterSave) {
          actions.afterSave()
        }
        return false
      })
  }
}

export { types, actions }
